/**
 * Shared proctoring warning components and hooks
 * Used across RealTimeInterview and iCode components
 */

import { useEffect } from "react";
import { toast } from "sonner";
import { AlertTriangle, Copy } from "lucide-react";

/**
 * Hook to show special key warning toast
 */
export const useSpecialKeyWarning = (showWarning) => {
  useEffect(() => {
    if (showWarning) {
      toast.error("System Keys Disabled", {
        description: "System keys (Alt, Windows, Function keys) are disabled for this assessment. Multiple attempts may result in disqualification.",
        duration: 5000,
        icon: <AlertTriangle className="h-5 w-5" />,
      });
    }
  }, [showWarning]);
};

/**
 * Hook to show right-click warning toast
 */
export const useRightClickWarning = (showWarning) => {
  useEffect(() => {
    if (showWarning) {
      toast.error("Right-Click Disabled", {
        description: "Right-click is disabled for this assessment. Multiple attempts may result in disqualification.",
        duration: 5000,
        icon: <AlertTriangle className="h-5 w-5" />,
      });
    }
  }, [showWarning]);
};

/**
 * Hook to show paste warning toast
 */
export const usePasteWarning = (showWarning) => {
  useEffect(() => {
    if (showWarning) {
      toast.error("Copy-Paste Disabled", {
        description: "Copy-paste is disabled for this assessment. Please write your own code. Multiple attempts may result in disqualification.",
        duration: 5000,
        icon: <Copy className="h-5 w-5" />,
      });
    }
  }, [showWarning]);
};

/**
 * Hook to show tab switch warning toast
 */
export const useTabSwitchWarning = (showWarning, violationCount) => {
  useEffect(() => {
    if (showWarning) {
      toast.warning("Tab/Window Switch Detected", {
        description: `Warning: Tab/Window switch detected! (${violationCount}/3). Your test will be submitted with 0 marks after 3 switches.`,
        duration: 5000,
        icon: <AlertTriangle className="h-5 w-5" />,
      });
    }
  }, [showWarning, violationCount]);
};
